export class ProjetoQuadraDto { }
